export default {
  title: 'Credenciais de Equipa',
  form: {
    username: {
      label: 'Nome de utilizador',
      placeholder: 'Nome de utilizador',
    },
    password: {
      label: 'Palavra-passe',
      placeholder: 'Palavra-passe',
    },
    button: {
      title: 'Guardar',
    },
    success: 'Informação guardada com sucesso.',
  },
};
